import { Link } from "react-router-dom";
import { characterList } from "@/mocks/characters";
import CharacterCard from "@/components/feature/CharacterCard";
import SectionHeading from "@/components/base/SectionHeading";

export default function CharacterSpotlight() {
  const items = characterList.slice(0, 4);

  return (
    <section className="page-wrap mt-14">
      <SectionHeading
        eyebrow="角色档案"
        title="精选角色介绍"
        description="本季讨论度最高的角色，点击进入查看完整设定与关联资讯。"
        action={
          <Link
            to="/characters"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-300 hover:text-accent-700"
          >
            全部角色
            <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-5">
        {items.map((item) => (
          <CharacterCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}